<template>
  <button
    type="button"
    class="rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    :class="colorClasses"
    @click="emit('click')"
  >
    <span class="sr-only">Close</span>
    <XIcon class="h-6 w-6" aria-hidden="true" />
  </button>
</template>

<script setup>
import { XIcon } from '@heroicons/vue/outline'
import { computed } from 'vue'

const props = defineProps({
  dark: Boolean,
})

const emit = defineEmits(['click'])

const colorClasses = computed(() =>
  props.dark
    ? 'text-gray-400 hover:text-gray-300'
    : 'text-gray-400 hover:text-gray-500 dark:hover:text-gray-300'
)
</script>
